// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import * as actions from '../state/documents/metadata/actions';
import { getTypes } from '../state/domains/types/actions';
import { getAuthors } from '../state/domains/authors/actions';
import { getInstitutions } from '../state/domains/institutions/actions';
import { getThemes } from '../state/domains/themes/actions';
import { getKeywords } from '../state/domains/keywords/actions';
import { getFolders } from '../state/domains/folders/actions';

// Components
import Metadata from '../components/Documents/Metadata';

function mapStateToProps(state) {
	return {
		domains: state.domains,
		document: state.documents.current
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch),
		getTypes: bindActionCreators(getTypes, dispatch),
		getAuthors: bindActionCreators(getAuthors, dispatch),
		getInstitutions: bindActionCreators(getInstitutions, dispatch),
		getThemes: bindActionCreators(getThemes, dispatch),
		getKeywords: bindActionCreators(getKeywords, dispatch),
		getFolders: bindActionCreators(getFolders, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Metadata);


// WEBPACK FOOTER //
// ./src/containers/MetadataContainer.js